import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, toDisplayString as _toDisplayString, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, vModelCheckbox as _vModelCheckbox } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "mt-2"
}
const _hoisted_2 = { class: "flex items-center justify-center w-full h-16 skeleton mt-4 tableCornerRadius bg-white" }
const _hoisted_3 = {
  key: 0,
  class: "mb-2"
}
const _hoisted_4 = {
  key: 1,
  class: "row w-full justify-between flex"
}
const _hoisted_5 = { class: "pt-5" }
const _hoisted_6 = {
  key: 0,
  class: "bg-white border border-lightgrey relative rounded"
}
const _hoisted_7 = { class: "pt-5 px-5 pb-5 flex flex-col h-full w-full" }
const _hoisted_8 = { class: "noScrollbar auditDivHeight overflow-y-auto pb-5" }
const _hoisted_9 = { class: "row flex flex-row w-full gap-5 mt-2 mb-3" }
const _hoisted_10 = { class: "w-6/12" }
const _hoisted_11 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_12 = {
  key: 0,
  class: "error-text"
}
const _hoisted_13 = { class: "w-6/12" }
const _hoisted_14 = ["min", "disabled"]
const _hoisted_15 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_16 = {
  key: 0,
  class: "error-text"
}
const _hoisted_17 = { class: "row flex flex-row w-full gap-5 items-center" }
const _hoisted_18 = { class: "w-6/12 mb-3" }
const _hoisted_19 = ["min", "disabled"]
const _hoisted_20 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_21 = {
  key: 0,
  class: "error-text"
}
const _hoisted_22 = { class: "w-6/12 mb-3" }
const _hoisted_23 = ["min", "disabled"]
const _hoisted_24 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_25 = {
  key: 0,
  class: "error-text"
}
const _hoisted_26 = { class: "row flex flex-row w-full gap-12" }
const _hoisted_27 = { class: "w-6/12" }
const _hoisted_28 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_29 = {
  key: 0,
  class: "error-text"
}
const _hoisted_30 = {
  key: 1,
  class: "text-red-500"
}
const _hoisted_31 = { class: "w-6/12" }
const _hoisted_32 = { class: "inputboxstyling mt-2 mb-3" }
const _hoisted_33 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_34 = {
  key: 0,
  class: "error-text"
}
const _hoisted_35 = { class: "row flex flex-row w-full gap-12" }
const _hoisted_36 = { class: "w-6/12 flex flex-col pt-2" }
const _hoisted_37 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_38 = {
  key: 0,
  class: "error-text"
}
const _hoisted_39 = { class: "w-6/12" }
const _hoisted_40 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_41 = {
  key: 0,
  class: "error-text"
}
const _hoisted_42 = {
  key: 1,
  class: "error-text"
}
const _hoisted_43 = { class: "flex gap-12" }
const _hoisted_44 = { class: "w-6/12 mt-2" }
const _hoisted_45 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_46 = {
  key: 0,
  class: "error-text"
}
const _hoisted_47 = { class: "w-6/12 mt-2 flex flex-col" }
const _hoisted_48 = {
  key: 0,
  class: "bottom-0 bg-white h-14 flex justify-between w-full rounded-b-sm flex-row-reverse",
  style: {"box-shadow":"0 -2px 10px rgba(0, 0, 0, 0.1)"}
}
const _hoisted_49 = { class: "flex items-center px-5" }
const _hoisted_50 = ["disabled"]
const _hoisted_51 = {
  key: 1,
  class: "bg-white border border-lightgrey relative rounded"
}
const _hoisted_52 = { class: "pt-5 px-5 pb-5 flex flex-col h-full w-full noScrollbar teamsHeight overflow-y-auto" }
const _hoisted_53 = { class: "oneSideBorder pb-2 border-b border-lightgrey" }
const _hoisted_54 = { class: "justify-between items-center flex h-8" }
const _hoisted_55 = { class: "flex justify-end" }
const _hoisted_56 = { class: "rounded flex text-xs mt-3" }
const _hoisted_57 = { class: "w-2/5" }
const _hoisted_58 = { class: "border border-lightgrey option mr-1 rounded" }
const _hoisted_59 = {
  key: 0,
  class: "p-2"
}
const _hoisted_60 = { class: "displayContainer overflow-y-scroll" }
const _hoisted_61 = ["onClick"]
const _hoisted_62 = { class: "p-3 pl-2 cursor-pointer mt-1" }
const _hoisted_63 = { class: "text-xs" }
const _hoisted_64 = { class: "w-3/5" }
const _hoisted_65 = { class: "w-full pt-0" }
const _hoisted_66 = { class: "border flex-col text-sm border-lightgrey ml-1 rounded" }
const _hoisted_67 = {
  key: 0,
  class: "p-2"
}
const _hoisted_68 = { class: "overflow-y-scroll displayContainer" }
const _hoisted_69 = { class: "flex items-center whitespace-nowrap" }
const _hoisted_70 = ["value", "id"]
const _hoisted_71 = ["for"]
const _hoisted_72 = { class: "pb-5 mb-14" }
const _hoisted_73 = {
  class: "bottom-0 bg-white h-14 flex justify-between w-full rounded-b-sm flex-row-reverse",
  style: {"box-shadow":"0 -2px 10px rgba(0, 0, 0, 0.1)"}
}
const _hoisted_74 = { class: "flex items-center px-5" }
const _hoisted_75 = {
  key: 2,
  class: "bg-white border border-lightgrey relative rounded"
}
const _hoisted_76 = { class: "pt-5 px-5 pb-5 flex flex-col h-full w-full noScrollbar teamsHeight overflow-y-auto" }
const _hoisted_77 = { key: 0 }
const _hoisted_78 = {
  class: "bottom-0 bg-white h-14 flex justify-between w-full rounded-b-sm flex-row-reverse",
  style: {"box-shadow":"0 -2px 10px rgba(0, 0, 0, 0.1)"}
}
const _hoisted_79 = { class: "flex items-center px-5" }
const _hoisted_80 = ["disabled"]
const _hoisted_81 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_dots_loader = _resolveComponent("dots-loader")!
  const _component_breadCrumbs = _resolveComponent("breadCrumbs")!
  const _component_AutoComplete = _resolveComponent("AutoComplete")!
  const _component_MultiSelect = _resolveComponent("MultiSelect")!
  const _component_tableData = _resolveComponent("tableData")!
  const _component_newTable = _resolveComponent("newTable")!

  return (_ctx.dotsLoading)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_dots_loader)
        ])
      ]))
    : (_openBlock(), _createElementBlock("div", {
        key: 1,
        class: _normalizeClass(_ctx.modalMode ? 'details-in-modal create-audit-in-modal' : 'px-5 pt-3 ')
      }, [
        (!_ctx.modalMode)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createVNode(_component_breadCrumbs, { routesArray: _ctx.routesArray }, null, 8, ["routesArray"])
            ]))
          : _createCommentVNode("", true),
        (!_ctx.modalMode)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, _cache[26] || (_cache[26] = [
              _createElementVNode("h1", { class: "title" }, "Create - Audit", -1)
            ])))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_5, [
          (_ctx.auditDiv==1)
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("div", null, [
                      _cache[28] || (_cache[28] = _createElementVNode("label", { class: "controllabel text-xs" }, "Audit period", -1)),
                      _createElementVNode("div", _hoisted_9, [
                        _createElementVNode("div", _hoisted_10, [
                          _withDirectives(_createElementVNode("input", {
                            type: "date",
                            onFocus: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.openCalendar && _ctx.openCalendar(...args))),
                            onkeydown: "return false",
                            onChange: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.checkFromPeriodFromDate && _ctx.checkFromPeriodFromDate(...args))),
                            placeholder: "Select Date",
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.presentAuditObject.period.fromDate) = $event)),
                            class: _normalizeClass({'is-invalid': _ctx.v$.presentAuditObject.period.fromDate.$error,'inputboxstylingForSelectAtPopup': _ctx.presentAuditObject.period.fromDate === '','stylingForInputboxstylingForSelectAtPopup': _ctx.presentAuditObject.period.fromDate !== ''})
                          }, null, 34), [
                            [_vModelText, _ctx.presentAuditObject.period.fromDate]
                          ]),
                          (_ctx.v$.presentAuditObject.period.fromDate.$error)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                                (_ctx.v$.presentAuditObject.period.fromDate.required.$invalid)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_12, "Required"))
                                  : _createCommentVNode("", true)
                              ]))
                            : _createCommentVNode("", true)
                        ]),
                        _cache[27] || (_cache[27] = _createElementVNode("div", { class: "p-1" }, "-", -1)),
                        _createElementVNode("div", _hoisted_13, [
                          _withDirectives(_createElementVNode("input", {
                            type: "date",
                            onFocus: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.openCalendar && _ctx.openCalendar(...args))),
                            onkeydown: "return false",
                            min: _ctx.presentAuditObject.period.fromDate,
                            placeholder: "Select date",
                            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.presentAuditObject.period.toDate) = $event)),
                            disabled: _ctx.presentAuditObject.period.fromDate === '' ? true : false,
                            class: _normalizeClass({'is-invalid': _ctx.v$.presentAuditObject.period.toDate.$error,'inputboxstylingForSelectAtPopup': _ctx.presentAuditObject.period.toDate === '','stylingForInputboxstylingForSelectAtPopup': _ctx.presentAuditObject.period.toDate !== ''})
                          }, null, 42, _hoisted_14), [
                            [_vModelText, _ctx.presentAuditObject.period.toDate]
                          ]),
                          (_ctx.v$.presentAuditObject.period.toDate.$error)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                                (_ctx.v$.presentAuditObject.period.toDate.required.$invalid)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_16, "Required"))
                                  : _createCommentVNode("", true)
                              ]))
                            : _createCommentVNode("", true)
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_17, [
                      _createElementVNode("div", _hoisted_18, [
                        _cache[29] || (_cache[29] = _createElementVNode("label", { class: "controllabel text-xs" }, "Audit Start Date", -1)),
                        _withDirectives(_createElementVNode("input", {
                          type: "date",
                          class: _normalizeClass(["mt-2", {
									'is-invalid': _ctx.v$.presentAuditObject.startDate.$error,'inputboxstylingForSelectAtPopup': _ctx.presentAuditObject.startDate === '','stylingForInputboxstylingForSelectAtPopup': _ctx.presentAuditObject.startDate !== ''
								}]),
                          onFocus: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.openCalendar && _ctx.openCalendar(...args))),
                          onkeydown: "return false",
                          min: _ctx.presentAuditObject.period.fromDate > _ctx.today ? _ctx.presentAuditObject.period.fromDate:_ctx.today,
                          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.presentAuditObject.startDate) = $event)),
                          onChange: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.checkForStartDate && _ctx.checkForStartDate(...args))),
                          disabled: _ctx.presentAuditObject.period.toDate == '',
                          placeholder: "Select Start Date"
                        }, null, 42, _hoisted_19), [
                          [_vModelText, _ctx.presentAuditObject.startDate]
                        ]),
                        (_ctx.v$.presentAuditObject.startDate.$error)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                              (_ctx.v$.presentAuditObject.startDate.required.$invalid)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_21, "Required"))
                                : _createCommentVNode("", true)
                            ]))
                          : _createCommentVNode("", true)
                      ]),
                      _cache[31] || (_cache[31] = _createElementVNode("div", { class: "p-1 mt-3" }, "-", -1)),
                      _createElementVNode("div", _hoisted_22, [
                        _cache[30] || (_cache[30] = _createElementVNode("label", { class: "controllabel text-xs" }, "Audit End Date", -1)),
                        _withDirectives(_createElementVNode("input", {
                          type: "date",
                          class: _normalizeClass(["mt-2", {
									'is-invalid': _ctx.v$.presentAuditObject.endDate.$error,'inputboxstylingForSelectAtPopup': _ctx.presentAuditObject.endDate === '','stylingForInputboxstylingForSelectAtPopup': _ctx.presentAuditObject.endDate !== ''
								}]),
                          onFocus: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.openCalendar && _ctx.openCalendar(...args))),
                          onkeydown: "return false",
                          min: _ctx.presentAuditObject.startDate,
                          "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.presentAuditObject.endDate) = $event)),
                          placeholder: "Select End date",
                          disabled: _ctx.presentAuditObject.startDate === '' ? true : false
                        }, null, 42, _hoisted_23), [
                          [_vModelText, _ctx.presentAuditObject.endDate]
                        ]),
                        (_ctx.v$.presentAuditObject.endDate.$error)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                              (_ctx.v$.presentAuditObject.endDate.required.$invalid)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_25, "Required"))
                                : _createCommentVNode("", true)
                            ]))
                          : _createCommentVNode("", true)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_26, [
                      _createElementVNode("div", _hoisted_27, [
                        _cache[33] || (_cache[33] = _createElementVNode("label", { class: "controllabel text-xs" }, "Audit Title", -1)),
                        _withDirectives(_createElementVNode("input", {
                          type: "text",
                          class: _normalizeClass(["inputboxstyling mt-2", {
									'is-invalid': _ctx.v$.presentAuditObject.title.$error || _ctx.checkAuditNames(_ctx.presentAuditObject.title)
								}]),
                          "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.presentAuditObject.title) = $event)),
                          placeholder: "Audit Title"
                        }, null, 2), [
                          [
                            _vModelText,
                            _ctx.presentAuditObject.title,
                            void 0,
                            { trim: true }
                          ]
                        ]),
                        (_ctx.v$.presentAuditObject.title.$error)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                              (_ctx.v$.presentAuditObject.title.required.$invalid )
                                ? (_openBlock(), _createElementBlock("div", _hoisted_29, "Required"))
                                : _createCommentVNode("", true)
                            ]))
                          : _createCommentVNode("", true),
                        (_ctx.checkAuditNames(_ctx.presentAuditObject.title))
                          ? (_openBlock(), _createElementBlock("div", _hoisted_30, _cache[32] || (_cache[32] = [
                              _createElementVNode("div", { class: "error-text" }, "Audit title already exists.", -1)
                            ])))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("div", _hoisted_31, [
                        _cache[34] || (_cache[34] = _createElementVNode("label", { class: "controllabel text-xs" }, "Audit Id", -1)),
                        _createElementVNode("div", _hoisted_32, _toDisplayString(_ctx.presentAuditObject.auditId), 1),
                        (_ctx.v$.presentAuditObject.auditId.$error)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                              (_ctx.v$.presentAuditObject.auditId.required.$invalid)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_34, "Required"))
                                : _createCommentVNode("", true)
                            ]))
                          : _createCommentVNode("", true)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_35, [
                      _createElementVNode("div", _hoisted_36, [
                        _cache[35] || (_cache[35] = _createElementVNode("label", { class: "controllabel text-xs" }, "Audit Leader", -1)),
                        _createVNode(_component_AutoComplete, {
                          modelValue: _ctx.presentAuditObject.teamLeader,
                          "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.presentAuditObject.teamLeader) = $event)),
                          suggestions: _ctx.userOptions,
                          onComplete: _ctx.asyncFind,
                          optionLabel: "label",
                          optionValue: "value",
                          field: "label",
                          placeholder: "Audit Leader",
                          forceSelection: true,
                          class: _normalizeClass(["p-inputtext-sm systemsstyling mt-2", {
									'p-invalid': _ctx.v$.presentAuditObject.teamLeader.$error,
									'has-options': _ctx.userOptions && _ctx.userOptions.length > 0,
                                    'no-options': !_ctx.userOptions.length &&  _ctx.searchValue !== '',
								}])
                        }, null, 8, ["modelValue", "suggestions", "onComplete", "class"]),
                        (_ctx.v$.presentAuditObject.teamLeader.$error)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
                              (_ctx.v$.presentAuditObject.teamLeader.required.$invalid)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_38, "Required"))
                                : _createCommentVNode("", true)
                            ]))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("div", _hoisted_39, [
                        _cache[38] || (_cache[38] = _createElementVNode("label", { class: "controllabel text-xs" }, "Frameworks (Maximum 3 Frameworks )", -1)),
                        _createVNode(_component_MultiSelect, {
                          modelValue: _ctx.presentAuditObject.frameworks,
                          "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.presentAuditObject.frameworks) = $event)),
                          options: _ctx.auditFrameworkArray,
                          selectionLimit: 3,
                          maxSelectedLabels: 3,
                          placeholder: "Frameworks",
                          multiple: true,
                          display: "chip",
                          emptyMessage: "",
                          class: _normalizeClass(["w-full custom-multiselect userSelect mt-2", {
									'p-invalid': _ctx.v$.presentAuditObject.frameworks.$error,
									'has-options': _ctx.auditFrameworkArray && _ctx.auditFrameworkArray.length > 0,
									'no-options':  !_ctx.auditFrameworkArray.length
								}])
                        }, {
                          maxElements: _withCtx(() => _cache[36] || (_cache[36] = [
                            _createElementVNode("span", { class: "text-xs" }, "Maximum 3 Frameworks", -1)
                          ])),
                          noResult: _withCtx(() => _cache[37] || (_cache[37] = [
                            _createElementVNode("span", { class: "text-xs" }, "No Frameworks Found", -1)
                          ])),
                          _: 1
                        }, 8, ["modelValue", "options", "class"]),
                        (_ctx.v$.presentAuditObject.frameworks.$error)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_40, [
                              (_ctx.v$.presentAuditObject.frameworks.required.$invalid)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_41, "Required"))
                                : _createCommentVNode("", true),
                              (_ctx.v$.presentAuditObject.frameworks.maxThreeItems.$invalid)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_42, "Max 3 frameworks can be selected"))
                                : _createCommentVNode("", true)
                            ]))
                          : _createCommentVNode("", true)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_43, [
                      _createElementVNode("div", _hoisted_44, [
                        _cache[40] || (_cache[40] = _createElementVNode("label", { class: "controllabel text-xs" }, "Location", -1)),
                        _createVNode(_component_MultiSelect, {
                          modelValue: _ctx.presentAuditObject.location,
                          "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.presentAuditObject.location) = $event)),
                          options: _ctx.optionsLocationArray,
                          placeholder: "Location",
                          display: "chip",
                          multiple: true,
                          filter: true,
                          optionLabel: "label",
                          class: _normalizeClass(["w-full custom-multiselect userSelect mt-2", {
									'p-invalid': _ctx.v$.presentAuditObject.location.$error,
									'has-options': _ctx.optionsLocationArray && _ctx.optionsLocationArray.length > 0,
									'no-options':  !_ctx.optionsLocationArray.length
								}])
                        }, {
                          noResult: _withCtx(() => _cache[39] || (_cache[39] = [
                            _createElementVNode("span", { class: "text-xs" }, "No Locations Found", -1)
                          ])),
                          _: 1
                        }, 8, ["modelValue", "options", "class"]),
                        (_ctx.v$.presentAuditObject.location.$error)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_45, [
                              (_ctx.v$.presentAuditObject.location.required.$invalid)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_46, "Required"))
                                : _createCommentVNode("", true)
                            ]))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("div", _hoisted_47, [
                        _cache[42] || (_cache[42] = _createElementVNode("label", { class: "controllabel text-xs mt-2" }, "Audit Members", -1)),
                        _createVNode(_component_MultiSelect, {
                          modelValue: _ctx.presentAuditObject.auditMembers,
                          "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.presentAuditObject.auditMembers) = $event)),
                          options: _ctx.auditorList,
                          optionLabel: "label",
                          dataKey: "value",
                          filter: true,
                          display: "chip",
                          placeholder: "Audit Members",
                          class: "w-full custom-multiselect userSelect mt-2"
                        }, {
                          empty: _withCtx(() => _cache[41] || (_cache[41] = [
                            _createElementVNode("span", { class: "text-xs" }, "No Members Found", -1)
                          ])),
                          _: 1
                        }, 8, ["modelValue", "options"])
                      ])
                    ])
                  ])
                ]),
                (_ctx.callsComplete)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_48, [
                      _createElementVNode("div", _hoisted_49, [
                        _createElementVNode("button", {
                          class: _normalizeClass(["mr-2", JSON.stringify(_ctx.dummyAuditObj) == JSON.stringify(_ctx.presentAuditObject) ? 'btndisabled pointer-events-none ' : 'btnprimary']),
                          onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.onCancelbtn()))
                        }, "Cancel", 2),
                        _createElementVNode("button", {
                          class: _normalizeClass(JSON.stringify(_ctx.dummyAuditObj) !== JSON.stringify(_ctx.presentAuditObject) || _ctx.pageType === 'edit' ? 'btnprimary' : 'btndisabled pointer-events-none '),
                          disabled: !(JSON.stringify(_ctx.dummyAuditObj) !== JSON.stringify(_ctx.presentAuditObject) || _ctx.pageType === 'edit'),
                          onClick: _cache[16] || (_cache[16] = ($event: any) => (_ctx.nextFrameworkMapbtnAudit()))
                        }, "Next", 10, _hoisted_50)
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ]))
            : (_ctx.auditDiv==2)
              ? (_openBlock(), _createElementBlock("div", _hoisted_51, [
                  _createElementVNode("div", _hoisted_52, [
                    _createElementVNode("div", _hoisted_53, [
                      _createElementVNode("div", _hoisted_54, [
                        _cache[43] || (_cache[43] = _createElementVNode("div", { class: "flex my-3" }, [
                          _createElementVNode("h2", { class: "header cursor-pointer" }, "Select Teams")
                        ], -1)),
                        _createElementVNode("div", _hoisted_55, [
                          _createElementVNode("button", {
                            class: _normalizeClass(["btnPrimaryPadding", _ctx.AddButtonDisableCondition() ? 'btnprimary' : 'btndisabled pointer-events-none']),
                            onClick: _cache[17] || (_cache[17] = 
//@ts-ignore
(...args) => (_ctx.addTeamsToTableView && _ctx.addTeamsToTableView(...args)))
                          }, "Add", 2)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_56, [
                        _createElementVNode("div", _hoisted_57, [
                          _createElementVNode("div", _hoisted_58, [
                            (_ctx.showFilters)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_59, [
                                  _withDirectives(_createElementVNode("input", {
                                    type: "text",
                                    "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.entityFilters.entity) = $event)),
                                    class: "inputboxstyling",
                                    placeholder: "Search Entities"
                                  }, null, 512), [
                                    [
                                      _vModelText,
                                      _ctx.entityFilters.entity,
                                      void 0,
                                      { trim: true }
                                    ]
                                  ])
                                ]))
                              : _createCommentVNode("", true),
                            _createElementVNode("div", _hoisted_60, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.displayEntitiesList, (location, index) => {
                                return (_openBlock(), _createElementBlock("div", {
                                  onClick: ($event: any) => (_ctx.clickedLocation(location)),
                                  class: _normalizeClass([_ctx.selectedLocation == location.value ? 'bg-primary hover:bg-primary text-white ml-2 mr-2' : 'hover:bg-lightgrey ml-2 mr-2', "rounded"]),
                                  key: index
                                }, [
                                  _createElementVNode("div", _hoisted_62, [
                                    _createElementVNode("p", _hoisted_63, _toDisplayString(location.label), 1)
                                  ])
                                ], 10, _hoisted_61))
                              }), 128))
                            ])
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_64, [
                          _createElementVNode("div", _hoisted_65, [
                            _createElementVNode("div", _hoisted_66, [
                              (_ctx.showFilters)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_67, [
                                    _withDirectives(_createElementVNode("input", {
                                      type: "text",
                                      "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.teamFilters.team) = $event)),
                                      class: "inputboxstyling",
                                      placeholder: "Search Teams"
                                    }, null, 512), [
                                      [
                                        _vModelText,
                                        _ctx.teamFilters.team,
                                        void 0,
                                        { trim: true }
                                      ]
                                    ])
                                  ]))
                                : _createCommentVNode("", true),
                              _createElementVNode("div", _hoisted_68, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.displayTeamList, (team, index) => {
                                  return (_openBlock(), _createElementBlock("div", {
                                    class: "h-7 flex justify-normal items-center cursor-pointer pr-5 pt-5 pb-5 pl-2 hover:bg-lightgrey mr-2 ml-2",
                                    key: index
                                  }, [
                                    _createElementVNode("div", _hoisted_69, [
                                      _withDirectives(_createElementVNode("input", {
                                        type: "checkbox",
                                        class: "checkbox inputboxstyling",
                                        "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.finalMappingObj[_ctx.selectedLocation]) = $event)),
                                        value: team._id,
                                        id: index
                                      }, null, 8, _hoisted_70), [
                                        [_vModelCheckbox, _ctx.finalMappingObj[_ctx.selectedLocation]]
                                      ]),
                                      _createElementVNode("label", {
                                        for: index,
                                        class: "pl-3 cursor-pointer"
                                      }, _toDisplayString(team.displayName) + " (" + _toDisplayString(team.controlCount == undefined || team.controlCount == null ? team.controlCount : 0 || team.controlCount) + " " + _toDisplayString('Controls') + ")", 9, _hoisted_71)
                                    ])
                                  ]))
                                }), 128))
                              ])
                            ])
                          ])
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_72, [
                      _cache[44] || (_cache[44] = _createElementVNode("h2", { class: "header mt-2 cursor-pointer" }, "Selected Teams", -1)),
                      _createVNode(_component_tableData, {
                        tableRowData: _ctx.mappingTableTeamsArray,
                        headersData: _ctx.teamDisplayHeaders
                      }, null, 8, ["tableRowData", "headersData"])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_73, [
                    _createElementVNode("div", _hoisted_74, [
                      _createElementVNode("button", {
                        class: "mr-2 btnprimary btnPrimaryPadding",
                        onClick: _cache[21] || (_cache[21] = ($event: any) => (_ctx.goBack()))
                      }, "Back"),
                      _createElementVNode("button", {
                        class: _normalizeClass(_ctx.mappingTableTeamsArray.length > 0 ? 'btnprimary' : 'btndisabled pointer-events-none'),
                        onClick: _cache[22] || (_cache[22] = ($event: any) => (_ctx.nextFrameworkMapbtnAudit()))
                      }, "Next", 2)
                    ])
                  ])
                ]))
              : (_ctx.auditDiv==3)
                ? (_openBlock(), _createElementBlock("div", _hoisted_75, [
                    _createElementVNode("div", _hoisted_76, [
                      (_ctx.teamDetailsTableArray.length > 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_77, [
                            _createVNode(_component_newTable, {
                              tableRowData: _ctx.teamDetailsTableArray,
                              headersData: _ctx.detailsEditHeaders,
                              locations: _ctx.optionsLocationArray,
                              userArray: _ctx.auditMembersArray,
                              departments: _ctx.filteredDepartments
                            }, null, 8, ["tableRowData", "headersData", "locations", "userArray", "departments"])
                          ]))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("div", _hoisted_78, [
                      _createElementVNode("div", _hoisted_79, [
                        _createElementVNode("button", {
                          class: "btnprimary btnPrimaryPadding mr-2",
                          onClick: _cache[23] || (_cache[23] = ($event: any) => (_ctx.goBack()))
                        }, "Back"),
                        (_ctx.pageType == 'add')
                          ? (_openBlock(), _createElementBlock("button", {
                              key: 0,
                              class: "btnprimary",
                              onClick: _cache[24] || (_cache[24] = ($event: any) => (_ctx.createAudit())),
                              disabled: _ctx.clickOnButton
                            }, "Create", 8, _hoisted_80))
                          : _createCommentVNode("", true),
                        (_ctx.pageType == 'edit')
                          ? (_openBlock(), _createElementBlock("button", {
                              key: 1,
                              class: _normalizeClass(["btnprimary", JSON.stringify(_ctx.dummyAuditObj) == JSON.stringify(_ctx.presentAuditObject) ? 'btndisabled pointer-events-none ' : 'btnprimary']),
                              onClick: _cache[25] || (_cache[25] = ($event: any) => (_ctx.updateAudit())),
                              disabled: _ctx.clickOnButton
                            }, "Update", 10, _hoisted_81))
                          : _createCommentVNode("", true)
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true)
        ])
      ], 2))
}